module.exports = __webpack_public_path__ + "img/antes_despues_334.5cec9fac.png";